import badges from './badges';
import getGoals from './get-goals';
import getPillars from './get-pillars';

export default {
  ...getGoals,
  ...getPillars,
  ...badges,
};
